// extracted by mini-css-extract-plugin
module.exports = {"form":"SaveFilter_form__22t48","input":"SaveFilter_input__2gA_I","cancel":"SaveFilter_cancel__2drle"};